import React, { useState } from "react";
import axios from "axios";
import { url } from "../link";
export default function VendorPaymentModal2025({
  show,
  onHide,
  pid,
  refreshPayments,
  am,
  p,
}) {
  const [vendorPaymentData, setVendorPaymentData] = useState({
    amountpaid: am,
    balancetobepaid: am - p,
    pid: pid, // store pid in state
  });

  // Update state when pid changes
  React.useEffect(() => {
    setVendorPaymentData((prev) => ({
      ...prev,
      pid: pid,
    }));
  }, [pid]);

  // Getter & Setter
  const handleVendorPaymentChange = (e) => {
    const { name, value } = e.target;
    setVendorPaymentData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit
  const submitVendorPayment = async () => {
    try {
      await axios.post(url + "vendorpayments", vendorPaymentData);
      refreshPayments();
      onHide();
      setVendorPaymentData({ amountpaid: "", balancetobepaid: "", pid: pid });
    } catch (err) {
      console.error("Error saving vendor payment:", err);
    }
  };

  if (!show) return null; // don't render if modal is hidden

  return (
    <div className="modal show fade d-block" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">Vendor Payment</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onHide}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Amount Paid</label>
              <input
                type="number"
                className="form-control"
                name="amountpaid"
                value={vendorPaymentData.amountpaid}
                onChange={handleVendorPaymentChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Balance to be Paid</label>
              <input
                type="number"
                className="form-control"
                name="balancetobepaid"
                value={vendorPaymentData.balancetobepaid}
                onChange={handleVendorPaymentChange}
              />
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onHide}>
              Close
            </button>
            <button className="btn btn-primary" onClick={submitVendorPayment}>
              Save Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
